import { useState } from 'react';
import TextField from '@mui/material/TextField';

export default function useCount() {
  const [count, setCount] = useState(1);

  const handleChangeCount = (flag) => {
    if (!flag) {
      if (count > 1) setCount(count - 1);
    } else setCount(count + 1);
  };

  function renderCounter() {
    return (
      <div className="wrapper-count-field">
        <span
          className="count-btn plus"
          onClick={() => handleChangeCount(true)}
        >
          +
        </span>
        <TextField
          type="number"
          inputProps={{
            style: {
              padding: 0,
              width: '51px',
              height: '40px',
              textAlign: 'center',
              borderColor: 'transpert'
            }
          }}
          value={count}
          classes={{ root: 'counterRoot' }}
        />
        {count > 1 ? (
          <span
            className="count-btn minus"
            onClick={() => handleChangeCount(false)}
          >
            -
          </span>
        ) : (
          <span className="empty-div"> </span>
        )}
      </div>
    );
  }

  return {
    count,
    renderCounter
  };
}
